import { makeStyles } from '@mui/styles';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles((theme: any) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1000,
        color: theme.palette.primary.main,
        backgroundColor: 'rgba(255,255,255,0.5)',
    },
}));

interface LoadingScreenProps {
    active: boolean;
}

export const LoadingScreen = ({ active }: LoadingScreenProps) => {
    const classes = useStyles();

    return (
        <Backdrop className={classes.backdrop} open={active}>
            <CircularProgress size={80} color='inherit' />
        </Backdrop>
    );
};
